// extracted by mini-css-extract-plugin
export default {"image":"SignOutModal___style-module__image___QE1Q7"};